import { Badge } from '@/components/ui/shadcn/badge';
import { useTranslations } from '@/hooks/useTranslations';
import { cn } from '@/lib/utils';

interface StatusBadgeProps {
    status: string;
    className?: string;
    statuses?: Array<{ value: string; label: string; color: string; isTerminal?: boolean }>;
}

export function StatusBadge({ status, className, statuses }: StatusBadgeProps) {
    const { t } = useTranslations();
    const statusConfig: Record<string, { label: string; variant: 'default' | 'secondary' | 'destructive' | 'outline' }> = {
        pending: { label: t('work_orders.show.workflow.registered', 'Registered'), variant: 'outline' },
        in_progress: { label: t('work_orders.show.workflow.in_progress', 'In Progress'), variant: 'default' },
        completed: { label: t('work_orders.show.workflow.completed', 'Completed'), variant: 'secondary' },
        cancelled: { label: t('work_orders.show.workflow.canceled', 'Canceled'), variant: 'destructive' },
        on_hold: { label: t('work_orders.show.workflow.on_hold', 'On Hold'), variant: 'outline' },
    };
    // Try to find status in dynamic data
    const dynamicStatus = statuses?.find((s) => s.value === status || s.value.toLowerCase() === status.toLowerCase());

    if (dynamicStatus) {
        // Use dynamic data with color classes from settings
        return (
            <Badge variant="outline" className={cn('', dynamicStatus.color, className)}>
                {dynamicStatus.label}
            </Badge>
        );
    }

    // Fall back to hardcoded config
    const config = statusConfig[status.toLowerCase()] || { label: status, variant: 'outline' as const };

    return (
        <Badge variant={config.variant} className={cn('capitalize', className)}>
            {config.label}
        </Badge>
    );
}
